import React from 'react'
import { Link } from 'react-router-dom'
import Avatar from '../Elements/Avatar'
import Thumbnail from '../Elements/Thumbnail'
import { InstagramIcon, TiktokIcon, TwitterIcon } from '../images/SnsIcon'
import { postdata } from '../contents/postdata'
import { profdata } from '../contents/profdata'
import './Profile.css'

export function ProfileThumbnailArea(props: any) {
  const profid: string = props.profid
  const multiline: boolean = props.multiline
  let thumbnails: any[] = []
  if (profid in postdata) {
    Object.keys(postdata[profid]).forEach((key) => {
      thumbnails.push(<Thumbnail key={key} authorid={profid} id={key} />)
    })
  }
  return (
    <div
      className={
        multiline
          ? 'profilepage-thumbnails multiline'
          : 'profilepage-thumbnails nomultiline'
      }
    >
      {thumbnails}
    </div>
  )
}

export function Profilebar(props: any) {
  const profid: string = props.profid
  let data: { [key: string]: string } = {
    name: 'このユーザは存在しません',
    avatarimage: '',
    profession: '',
    intro: '',
    twitter: '',
    tiktok: '',
    instagram: '',
  }
  // profidがprofdataに存在するか調べる
  if (profid in profdata) data = profdata[profid]
  // SNSアイコンを表示する部分
  let sns: any[] = []
  if (data['instagram'] != '') {
    sns.push(
      <a
        key={'instagram'}
        className="icon-button"
        href={'https://instagram.com/' + data.instagram}
      >
        <InstagramIcon />
      </a>,
    )
  }
  if (data['tiktok'] != '') {
    sns.push(
      <a
        key={'tiktok'}
        className="icon-button"
        href={'https://www.tiktok.com/' + data.tiktok}
      >
        <TiktokIcon />
      </a>,
    )
  }
  if (data['twitter'] != '') {
    sns.push(
      <a
        key={'twitter'}
        className="icon-button"
        href={'https://twitter.com/' + data.twitter}
      >
        <TwitterIcon />
      </a>,
    )
  }
  return (
    <div className="profilepage-avatar">
      <Link to={'/' + profid} className="profilepage-avatar-image">
        <Avatar src={data['avatarimage']} />
      </Link>
      <div className="profilepage-avatar-right">
        <Link to={'/' + profid} className="profilepage-avatar-name">
          {data['name']}
        </Link>
        <p className="profilepage-avatar-profession">{data['profession']}</p>
        <p className="profilepage-avatar-intro">{data['intro']}</p>
        <div className="profilepage-snsicons">{sns}</div>
      </div>
    </div>
  )
}
